import { useMutation, useQueryClient } from 'react-query';

import { announcementApi } from 'src/Services/API';
import {
  AnnouncementDto,
  CreateAnnouncementDto,
  UpdateAnnouncementDto,
} from 'src/types/announcement.types';

const invalidationKeys = [['announcements'], ['active-announcement']];

const invalidate = (queryClient: ReturnType<typeof useQueryClient>) => {
  invalidationKeys.forEach(key => queryClient.invalidateQueries({ queryKey: key }));
};

export const useCreateAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation<AnnouncementDto, unknown, CreateAnnouncementDto>(
    dto => announcementApi.create(dto),
    { onSuccess: () => invalidate(queryClient) }
  );
};

export const useUpdateAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation<AnnouncementDto, unknown, { id: string; dto: UpdateAnnouncementDto }>(
    ({ id, dto }) => announcementApi.update(id, dto),
    { onSuccess: () => invalidate(queryClient) }
  );
};

export const usePublishAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation<AnnouncementDto, unknown, string>(id => announcementApi.publish(id), {
    onSuccess: () => invalidate(queryClient),
  });
};

export const useUnpublishAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation<AnnouncementDto, unknown, string>(id => announcementApi.unpublish(id), {
    onSuccess: () => invalidate(queryClient),
  });
};

export const useDeleteAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, string>(id => announcementApi.delete(id), {
    onSuccess: () => invalidate(queryClient),
  });
};
